@if (isSwitchingAccount() || loading) {
  <section
    aria-label="Account summary loading"
    class="flex flex-col lg:flex-row lg:justify-between"
  >
    <div class="mb-2 lg:mb-6">
      <h1 class="mb-2.5 text-base font-bold">Welcome</h1>
      <div
        class="font-montserrat mb-0 h-12 w-48 animate-pulse rounded bg-white/20"
        aria-hidden="true"
      ></div>
    </div>

    <dl
      aria-label="Billing summary loading"
      class="font-montserrat flex flex-col justify-center gap-4 py-2 text-sm lg:max-w-96.25 lg:border-l lg:border-white lg:pl-6"
    >
      <div class="flex flex-wrap">
        <dt class="font-bold">Billing Address:</dt>
        <dd class="ml-2 h-5 w-64 animate-pulse rounded bg-white/20"></dd>
      </div>

      <div class="flex flex-wrap items-baseline gap-1">
        <dt class="font-bold">Last Payment:</dt>
        <dd class="ml-2 h-5 w-48 animate-pulse rounded bg-white/20"></dd>
      </div>

      <div class="mt-2 h-5 w-32 animate-pulse rounded bg-white/20"></div>
    </dl>
  </section>
} @else {
  <section
    aria-label="Account summary"
    class="flex flex-col lg:flex-row lg:justify-between"
  >
    <div class="mb-2 lg:mb-6">
      <h1 class="mb-2.5 text-base font-bold">Welcome</h1>
      @if (accountName) {
        <div
          class="font-montserrat mb-0 text-4xl leading-[1.2] font-light wrap-break-word italic"
          aria-hidden="true"
        >
          {{ accountName }}
        </div>
      }
    </div>

    @if (
      billingAddress ||
      currentBalance != null ||
      (lastPaymentDate && lastPaymentAmount != null) ||
      hasMultipleAccounts()
    ) {
      <dl
        aria-label="Billing summary"
        class="font-montserrat flex flex-col justify-center gap-2 py-2 text-sm lg:max-w-96.25 lg:border-l lg:border-white lg:pl-6"
      >
        <ng-container *ngxPermissionsOnly="Permission.BILLING_READ">
          @if (billingAddress) {
            <div class="flex flex-wrap">
              <dt class="font-bold">Billing Address:</dt>
              <dd class="ml-2 uppercase">{{ billingAddress }}</dd>
            </div>
          }

          @if (lastPaymentDate && lastPaymentAmount != null) {
            <div class="flex flex-wrap items-baseline gap-1">
              <dt class="font-bold">Last Payment:</dt>
              <dd class="ml-2 uppercase">
                {{ lastPaymentAmount | currency }} on
                <time [attr.datetime]="lastPaymentDate | date: 'yyyy-MM-dd'">{{
                  lastPaymentDate | date: 'MMM d, y'
                }}</time>
              </dd>
            </div>
          }
        </ng-container>

        <div class="mt-2 flex items-center gap-4">
          <a
            *ngxPermissionsOnly="Permission.BILLING_READ"
            class="font-montserrat inline-flex items-center rounded-sm text-xs font-bold tracking-[2px] text-white uppercase underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1 focus-visible:ring-offset-transparent"
            [routerLink]="['/billing']"
            >Billing details</a
          >
          @if (hasMultipleAccounts()) {
            <button
              type="button"
              (click)="openAccountSwitcher()"
              class="font-montserrat inline-flex cursor-pointer items-center gap-1 rounded-sm border-none bg-transparent text-xs font-bold tracking-[2px] text-white uppercase underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1 focus-visible:ring-offset-transparent"
            >
              <mat-icon class="text-xs" aria-hidden="true">swap_horiz</mat-icon
              >Switch Accounts
            </button>
          }
        </div>
      </dl>
    }
  </section>
}
